import './Sidebar.scss';
import { FC } from 'react';
import InboxIcon from "../../icons/InboxIcon";
import LogoutIcon from "../../icons/LogoutIcon";
import DashboardIcon from "../../icons/DashboardIcon";
import { NavLink } from "react-router-dom";
import { useDispatchEx, useSelectorEx } from "../../../hooks/redux";
import { asyncLogoutAction } from "../../../redux/slices/auth/authAction";

interface NavLinkClassNames {
    isActive: boolean;
    isPending: boolean;
}

const Sidebar: FC = () => {
    const dispatch = useDispatchEx();
    const { globalUnreadCount } = useSelectorEx(state => state.orders);

    const getNavLinkClassNames = ({ isActive, isPending }: NavLinkClassNames): string => {
        return isPending ? "pending" : isActive ? "active" : "";
    };

    return (
        <aside className="sidebar">
            <div className="sidebar__inner">
                <div className="sidebar__container">
                    <div className="sidebar__header">
                        <span>Админ панель</span>
                    </div>
                    <div className="sidebar__wrapper">
                        <ul className="sidebar__list">
                            <li className="sidebar__list-item">
                                <NavLink className={getNavLinkClassNames} to={'/admin/orders'}>
                                    <div className="sidebar__icon-wrapper">
                                        <InboxIcon />
                                        {globalUnreadCount > 0 && (
                                            <span className="sidebar__badge">{globalUnreadCount}</span>
                                        )}
                                    </div>
                                    <span className="sidebar__text">Заявки на перевод</span>
                                </NavLink>
                            </li>

                            <li className="sidebar__list-item">
                                <NavLink className={getNavLinkClassNames} to={'/admin/currency-rates'}>
                                    <div className="sidebar__icon-wrapper">
                                        <DashboardIcon />
                                    </div>
                                    <span className="sidebar__text">Валюты и проценты</span>
                                </NavLink>
                            </li>

                            <li className="sidebar__list-item">
                                <a onClick={() => dispatch(asyncLogoutAction())}>
                                    <div className="sidebar__icon-wrapper">
                                        <LogoutIcon />
                                    </div>
                                    <span className="sidebar__text">Выйти</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;